var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 324,
    viewBox: "0 0 432 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.185 0.616163C258.005 6.53723 266.854 62.2764 296.902 91.9638C327.346 122.041 391.173 129.904 390.358 172.696C389.541 215.621 326.301 222.268 293.886 250.412C265.899 274.711 253.186 321.789 216.185 323.92C178.767 326.074 157.313 284.461 128.991 259.907C96.6924 231.907 46.1506 215.219 41.7485 172.696C37.2307 129.057 77.6178 96.1459 108.848 65.338C139.769 34.8343 173.183 -5.47237 216.185 0.616163Z",
    fill: "url(#paint0_linear_2873_109864)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2873_109864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.725 53.1954C256.368 33.9987 321.384 92.1008 340.985 165.253C355.639 219.941 295.993 254.211 242.433 268.562C185.671 283.772 111.505 288.861 95.975 230.903C75.7106 155.276 110.658 73.0417 184.725 53.1954Z",
    fill: "url(#paint1_linear_2873_109864)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.203 107.262L229.067 96.4919C229.484 96.4308 229.909 96.462 230.313 96.5832C230.717 96.7045 231.091 96.913 231.409 97.1947C231.727 97.4763 231.982 97.8246 232.157 98.2157C232.332 98.6069 232.422 99.0319 232.422 99.4619V224.538C232.422 224.967 232.332 225.392 232.157 225.782C231.983 226.173 231.728 226.521 231.411 226.803C231.093 227.084 230.72 227.293 230.317 227.414C229.913 227.536 229.489 227.568 229.073 227.508L155.197 216.738C153.796 216.534 152.515 215.821 151.587 214.73C150.66 213.639 150.149 212.243 150.149 210.798V113.202C150.149 111.757 150.66 110.361 151.587 109.27C152.515 108.179 153.796 107.466 155.197 107.262H155.203ZM161.908 118.41V205.59L220.67 214.164V109.836L161.908 118.41ZM238.299 204H255.927V120H238.299V108H261.803C263.362 108 264.856 108.632 265.958 109.757C267.06 110.882 267.68 112.409 267.68 114V210C267.68 211.591 267.06 213.117 265.958 214.243C264.856 215.368 263.362 216 261.803 216H238.299V204ZM198.34 162L214.794 186H200.691L191.289 172.284L181.887 186H167.784L184.237 162L167.784 138H181.887L191.289 151.716L200.691 138H214.794L198.34 162Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2873_109864",
    x: 82.293,
    y: 45.4908,
    width: 268.943,
    height: 245.122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_109864"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2873_109864",
    result: "effect2_dropShadow_2873_109864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2873_109864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2873_109864",
    x1: 41.4004,
    y1: 162,
    x2: 390.366,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2873_109864",
    x1: 86.3469,
    y1: 194.971,
    x2: 331.357,
    y2: 129.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIllustration);
export default __webpack_public_path__ + "static/media/report_illustration.7a9ff5e49949fcb43ba8fca036c07308.svg";
export { ForwardRef as ReactComponent };